import React from 'react';
import Carousel from 'react-gallery-carousel';
import 'react-gallery-carousel/dist/index.css';
import { Icon } from 'semantic-ui-react';

const HomeCarousel = ({ images, time = 8000 }) => {
  if (images.length === 0) return null;

  return (
    <Carousel
      className="aridhia-image-carousel"
      images={images}
      isAutoPlaying
      hasLeftButton={false}
      hasRightButton={false}
      hasIndexBoard={false}
      autoPlayInterval={time}
      playIcon={false}
      pauseIcon={false}
      style={{ height: 600 }}
      shouldMaximizeOnClick
      shouldMinimizeOnClick
      maxIcon={<Icon name="expand" className="white-icon mt-10 mr-10" />}
      minIcon={<Icon name="compress" className="white-icon mt-10 mr-10" />}
    />
  );
};

export default HomeCarousel;
